import React, {
  useState,
  useEffect
} from 'react';
import * as Sentry from '@sentry/browser';

import {
  BaseAPI,
  APIError,
} from './BaseAPI';
import {
  getSession,
  setSession,
} from './SessionUtils';

import {
  Session
} from '../types';

class SessionAPI extends BaseAPI {
  path = 'session/'
}

let sessionAPI: SessionAPI;
function getAPI() {
  if (!sessionAPI) sessionAPI = new SessionAPI();
  return sessionAPI;
}

function useSession(path=''): [Session, boolean, (() => Promise<void>), ((data: any) => Promise<(boolean | Session)[] | (boolean | undefined)[]>)]  {
  const [session, setCurrentSession] = useState(getSession());
  const [loading, setLoading] = useState(true);

  const loadSession = async () => {
    if (!(window as any)._cache) {
      (window as any)._cache = {};
    }

    if ((window as any)._cache.session) {
      setCurrentSession(setSession((window as any)._cache.session));
    }

    setLoading(true);
    const sessionAPI = getAPI();
    try {
      const data: Session = (await sessionAPI.get(path)) as Session;
      setCurrentSession(setSession(data));
      (window as any)._cache.session = data;

      if (data && (data as any).csrftoken) (window as any).csrftoken =  (data as any).csrftoken;
      if (data.student) {
        Sentry.configureScope(function(scope) {
          if (data.student) {
            console.log('setting up user data', data.student)
            scope.setUser({
              id: data.student.user_id,
              email: data.student.email,
              full_name: data.student.full_name,
              nim: data.student.nim,
            });
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);

  }

  const updateSession = async (data: any) => {
    let success = false;
    setLoading(true);
    const sessionAPI = getAPI();
    try {
      const [result, response, error] = await sessionAPI.post(data, path);
      if (result && result.success) {
        const session = await sessionAPI.get(path);
        setCurrentSession(setSession(session as Session));
        success = true;
      }
      setLoading(false);
      return [success, result];
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
    return [success, undefined];
  };

  useEffect(() => {
    loadSession();
  }, []);

  return [
    session,
    loading,
    loadSession,
    updateSession,
  ];
}

export {
  getAPI,
  useSession,
};
